/* istanbul ignore file */
import ChangeServiceForm_initial from "./ChangeServiceForm_initial.module.scss";
import ChangeServiceForm_initial_for_LP from "./ChangeServiceForm_initial_for_LP.module.scss";

export default {
  ChangeServiceForm_initial,
  ChangeServiceForm_initial_for_LP,
};
